import { ProfileImageIcon } from '@sketchnote/icons';
import { Avatar, AvatarGroup, Button, CheckboxKanbanItem } from '@sketchnote/shared-components';
import { GridApi } from 'ag-grid-community';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { memo } from 'react';
import { useFileStore } from 'src/features/files';
import { useTableStore } from 'src/features/list/store';
import useOnClickOutside from 'use-onclickoutside';
const AssigneeCell = ({
  data: item,
  api,
  onChange,
}: {
  data: any;
  api: GridApi;
  onChange?: (val) => void;
}) => {
  const myRef = useRef(null);

  const router = useRouter();
  const currentFile = useFileStore(
    useCallback((s) => s.files[router.query.slug as string], [router.query.slug as string])
  );

  const [assigneeOptions, setAssigneeOptions] = useState<any[]>([]);
  const [selectedAssignees, setSelectedAssignees] = useState<any[]>([]);
  const { setItem, onUpdateItemField } = useTableStore((s) => ({
    setItem: s.setItem,
    onUpdateItemField: s.onUpdateItemField,
  }));

  useEffect(() => {
    const assignees = currentFile?.membersWithAccess?.map((obj) => ({
      firstname: obj.firstname,
      label: obj.firstname,
      value: obj.memberId,
      memberId: obj.memberId,
      avatar: obj.avatar,
    }));
    setAssigneeOptions(assignees || []);
  }, [currentFile?.membersWithAccess]);

  useEffect(() => {
    setSelectedAssignees(item?.assignee?.map((obj) => obj.memberId) || []);
  }, [item?.assignee]);

  const handleCheck = (value) => {
    const index = selectedAssignees.indexOf(value);
    if (index > -1) {
      selectedAssignees.splice(index, 1);
    } else {
      selectedAssignees.push(value);
    }
    setSelectedAssignees([...selectedAssignees]);
  };

  const handleDone = () => {
    if (onChange) onChange(selectedAssignees);
    else if (item?.id) {
      const assigneesList = assigneeOptions.filter((assignee) =>
        selectedAssignees.includes(assignee.value)
      );
      setItem({
        columnId: item.isSubtask ? item.parentColumn : item.colId,
        item: { ...item, assignee: assigneesList },
        itemId: item.id,
      });
      onUpdateItemField({
        item: { assignee: assigneesList, id: item?.id },
        keys: ['assignee'],
      });
    }
    api.stopEditing();
  };
  useOnClickOutside(myRef, handleDone);

  if (!item) return <></>;
  return (
    <div className="more-menu-popover bg-white" ref={myRef}>
      <div className="flex flex-col gap-0 justify-center">
        <div
          style={{
            maxHeight: '300px',
            overflow: 'auto',
          }}
        >
          {assigneeOptions?.map((assignee, index) => {
            const checked = selectedAssignees.includes(assignee.value);
            return (
              <div
                key={`{${assignee.memberId}-${index}}`}
                className="flex gap-8 px-10 h-40 items-center  min-w-200 cursor-pointer hover:bg-gray-300"
                onClick={handleCheck.bind(null, assignee.value)}
              >
                <CheckboxKanbanItem
                  onChange={handleCheck.bind(null, assignee.value)}
                  checked={checked}
                  size="small"
                  color="#33CC48"
                />
                <img
                  src={assignee.avatar}
                  alt={assignee.label}
                  className="h-20 w-20 rounded-full object-cover"
                  style={{ border: '1px solid #D5D7DD' }}
                />
                <p className="text-sm font-regular text-gray-999 leading-20">{assignee.label}</p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex justify-end px-10 py-8">
        <Button onClick={handleDone}>Done</Button>
      </div>
    </div>
  );
};

const Assignee = (item) => (
  <div className="flex items-center">
    {item.assignee?.length ? (
      <>
        <AvatarGroup maxCount={2}>
          {item.assignee.map((obj, index) => (
            <Avatar
              name={cn(obj.firstname, obj.lastname)}
              src={obj.avatar}
              type="photo"
              key={`{${obj.memberId}-${index}}`}
              wrapperClassName="-mr-8 border-2 border-white transform transition duration-500 hover:scale-125"
              size="sm"
            />
          ))}
        </AvatarGroup>

        {item.assignee.length > 2 && (
          <Avatar
            name={item.assignee.length - 2}
            tooltip={false}
            type={'initials'}
            src={''}
            size="sm"
            wrapperClassName="-ml-10 border-white border-1 transform transition duration-500 hover:scale-125"
          />
        )}
      </>
    ) : (
      <div className="flex h-full items-center">
        <ProfileImageIcon
          size={10}
          wrapperClass="border-2 border-gray-400 text-gray-400 border-dotted p-5 rounded-full"
        />
      </div>
    )}
  </div>
);

export const AssigneeCellEditor = memo(AssigneeCell);
